import * as z from 'zod';

export type SubscriptionItemPricingOverrideFormSchemaValues = z.infer<typeof subscriptionItemPricingOverrideFormSchema>;
export const subscriptionItemPricingOverrideFormSchema = z.object({
    valid_from: z.string().nonempty(),
    valid_to: z.string().optional().nullable(),
    // Sent as a string so the decimal reaches the API exactly as typed.
    coefficient: z.string().refine((value) => Number(value) > 0, { message: 'Must be greater than 0' }),
});
